"use client";
// Next imports
import Image from "next/image";
import { usePathname } from "next/navigation";
// Material UI imports
import { Box, Avatar, IconButton } from '@mui/material';
// context imports
// import { useTheme } from '@/context';
import { useAuth } from '@/context/AuthContext';
import { useGlobalStateContext } from "@/context/GlobalContext";
// component imports
// import { ThemeSwitch } from "@int-traderjoes/ui-components-library";
import { Guide, ProfileMenu } from '@/components/';
// assets imports
import ProductPortalLogo from "@/assets/images/ideation-phase-images/ProductPortalLogo.svg";
import HamburgerIcon from "@/assets/images/ideation-phase-images/HamburgerIcon.svg";
import TjHeader from "@/assets/images/ideation-phase-images/TjHeader.svg";
import VendorHeader from "@/assets/images/ideation-phase-images/VendorHeader.svg";
// hooks imports
import { useIsVendor } from "@/hooks/useIsVendor";
import { useUserType } from "@/hooks/useUserType";
// styles imports
import './header.scss';
import { useMemo } from "react";

/** Routes where the header Guide icon should be hidden. */
const HIDE_GUIDE_PATHS = ["/userNotFound"] as const;
const shouldShowGuide = (pathname: string | null | undefined): boolean => {
  if (!pathname) return true;
  return !(HIDE_GUIDE_PATHS as readonly string[]).includes(pathname);
}

interface HeaderProps {
  showSearch: boolean;
  hideProfileIcon?: boolean;
  /** True when Header is rendered inside the `(authorised)` app shell. */
  isAuthorisedShell?: boolean;
}

const LogoNHamburgerIconComp = (
  { userAuthenticated, showSearch, pathname, toggleDrawer }: { userAuthenticated: boolean; showSearch: boolean; pathname: string; toggleDrawer: () => void; }
)=>{
  if(userAuthenticated && !showSearch){
    return <Box className="flex gap-4">
    {pathname !== '/home' && (
      <IconButton sx={{ padding: 0 }} onClick={toggleDrawer}>
        <Avatar src={HamburgerIcon.src} sx={{ width: 24, height: 24 }} />
      </IconButton>
    )}
    <Image
      src={ProductPortalLogo}
      alt="Product Portal"
      width={32}
      height={32}
    />
  </Box>
  }
}

const LogoComp = (
  { userAuthenticated, pathname, showsearch, isAuthorisedShell }: { userAuthenticated: boolean; pathname: string; showsearch: boolean; isAuthorisedShell: boolean; }
) => {
  const isVendor = useIsVendor();
  const userType = useUserType();

  const headerLogoSrc = isVendor
    ? VendorHeader.src
    : userType === "TJ"
      ? TjHeader.src
      : null;

      if (
        showsearch &&
        ((!userAuthenticated && !isAuthorisedShell) || pathname === '/home')
      ){
        if (!headerLogoSrc) return null;

        return (
          <h1>
             <Box
              component="img"
              src={headerLogoSrc}
              alt="Header Logo"
            />
          </h1>
        ) 
      }
}

const Header:React.FC<HeaderProps>= ({
  showSearch = true,
  hideProfileIcon = false,
  isAuthorisedShell = false,
})=> {
  // uncomment this to use the theme switch
  // const { darkMode, toggleTheme } = useTheme();
  const { userAuthenticated } = useAuth();
  const pathname = usePathname(); // This hook gives the current route pathname
  const userType = useUserType();
  const showGuide = useMemo(
    () => userType === "TJ" && shouldShowGuide(pathname),
    [pathname, userType]
  );

  const { isSidebarVisible, setIsSidebarVisible } = useGlobalStateContext();

  
  const toggleDrawer = () => {
    setIsSidebarVisible(!isSidebarVisible);
  };
  
  return (
    <header className={`flex header items-center p-4 lg:p-6 bg-[#f2f2f2] dark:bg-TJ-Dark text-white ${!userAuthenticated && ('header-small')}`} >
      
        <LogoComp 
        userAuthenticated={userAuthenticated} pathname={pathname}
        showsearch={showSearch}
        isAuthorisedShell={isAuthorisedShell}
         />
        {/* <SearchBoxComp/> */}
        <LogoNHamburgerIconComp
          userAuthenticated={userAuthenticated}
          showSearch={showSearch}
          pathname={pathname}
          toggleDrawer={toggleDrawer}
        />
      <nav className='nav h-10'>
        <ul className="flex h-full space-x-4 items-center">
          {/* <li
            className="theme-switch-disabled"
            title="Theme is locked to light mode"
            style={{ pointerEvents: 'none', cursor: 'not-allowed' }}
          >
            <ThemeSwitch
              darkmode={darkMode ? 'dark' : ''}
              toggleTheme={() => {}} // Disable toggle functionality
            />
          </li> */}
          {!hideProfileIcon && (
            <>
              {showGuide && (
                <li className="guide-item">
                  <Guide />
                </li>
              )}
              <li className='h-full profile-icon'>
                <Box>
                  <ProfileMenu isUserAuthenticated={userAuthenticated} />
                </Box>
              </li>
            </>
          )}
        </ul>
      </nav>
    </header>
  );
}

export default Header;